import React from "react";
import { useLanguage } from "../../i18n";

// Shown right after a paid plan upgrade/downgrade actually lands (see
// waitForPlanChange() in OwnerPlans.tsx / waitForPro() in TenantPlan.tsx) —
// a toast alone is easy to miss right after closing the Razorpay checkout
// modal, so a real confirmation the owner/tenant has to dismiss makes the
// "did my payment actually go through" moment unambiguous.
export function PlanChangedModal({ planName, onClose }: { planName: string; onClose: () => void }) {
  const { t } = useLanguage();
  return (
    <>
      <div className="filter-backdrop" onClick={onClose} />
      <div className="filter-sheet" style={{ textAlign: "center" }}>
        <div className="filter-sheet-handle" />
        <div className="plan-success-icon">✓</div>
        <div className="reg-title" style={{ marginBottom: 6 }}>{t("planChanged.title", { plan: planName })}</div>
        <div className="sub" style={{ marginBottom: 20 }}>{t("planChanged.body", { plan: planName })}</div>
        <button className="btn-solid" onClick={onClose}>{t("planChanged.okBtn")}</button>
      </div>
    </>
  );
}
